export default [
  {
    label: '阿里云图标',
    list: [
      'icon-anzhuang',
      'icon-42gongyegongcheng_weixiu',
      'icon-wangzhantubiaoji2TW',
      'icon-zixun',
      'icon-tuihuobaozhang',
      'icon-huanhuobz',
      'icon-ico_yishenggongzuozhan_meilijiance',
      'icon-jianding',
      'icon-xsc_kan',
      'icon-xunjianguanliA',
      'icon-kesuguanli-',
      'icon-songxiuchulipY',
      'icon-biaoyang',
      'icon-qita',

      // 'icon-huanhuobz',
      
      '',
      '',
    ]
  }
]
